import { useContext, useEffect, useState } from 'react'
import { CheckBox } from '@nv/basic-components'
import { NVButton } from '@nv/basic-components'
import { LoginFlowContext, useVoterUserContext } from '@nv/contexts'
import { VoterOnboardingContext } from '@nv/contexts'
import SecurityIcon from '@nv/images/design/security-icon'
import { JumioAuthService } from '@nv/services'
import { VoterAuthService } from '@nv/services'
import { nxConfig } from '@nv/utils'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './AuthCodeMethod.module.scss'
import '@djthoms/pretty-checkbox'

export const AuthCodeMethod = () => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  const navigate = useNavigate()
  const { authMethod, setAuthMethod } = useContext(VoterOnboardingContext)
  const [activeSelection, setActiveSelection] = useState(null)
  const [notValid, setNotValid] = useState(true)
  const [serverError, setServerError] = useState(false)
  const VoterUser = useVoterUserContext().voterUser

  const LOGIN_CONTEXT = useContext(LoginFlowContext)
  const isLoginFlow = LOGIN_CONTEXT.loginFlow !== 'Onboarding'

  const onChangeMethod = ({ method }) => {
    setAuthMethod(method)
    setActiveSelection(method)
  }

  const onClickNext = async () => {
    setServerError(false)
    let sent
    if (authMethod === 'AuthApp') {
      navigate('/voting/voter-verify/verify')
      return
    } else if (authMethod === 'Email') {
      if (LOGIN_CONTEXT.loginFlow === 'Forgot Password') {
        sent = await VoterAuthService.sendEmailCodePasswordResetFlow()
      } else {
        sent = await VoterAuthService.sendEmailCode()
      }
      if (sent.success) {
        navigate('/voting/voter-verify/verify')
      }
    } else if (authMethod === 'FaceId') {
      const sent = await JumioAuthService.startFacedIdLogin()
      if (sent.success) {
        navigate('/voting/voter-auth/jumio', { state: { iframeUrl: sent.iframeUrl, view: 'Login' } })
      }
    } else {
      if (LOGIN_CONTEXT.loginFlow === 'Forgot Password') {
        sent = await VoterAuthService.sendSMSCodePasswordResetFlow(currentLanguage)
      } else {
        sent = await VoterAuthService.sendSMSCode(currentLanguage)
      }
      if (sent.success) {
        navigate('/voting/voter-verify/verify')
      }
    }
    if (sent.error) {
      setServerError(true)
    }
  }

  useEffect(() => {
    if (activeSelection) {
      setNotValid(false)
    }
  }, [activeSelection])

  return (
    <div>
      <div className={styles['container']}>
        <div
          className={clsx(styles['body'], {
            [styles['body--login']]: isLoginFlow,
          })}
        >
          <div className={styles['body__username']}>
            <span className={styles['body__username__label']}>{t('auth.yourUsername.voter')}</span>
            <span className={styles['body__username__value']}>{VoterUser?.username}</span>
          </div>

          <div className={styles['form']}>
            <span className={styles['form__heading']}>{t('auth.authMethod.heading')}</span>

            <div className={styles['form__inputs']}>
              {VoterUser.authAppIsSetup && (
                <CheckBox
                  checked={activeSelection === 'AuthApp'}
                  onChange={() => onChangeMethod({ method: 'AuthApp' })}
                  label={t('auth.authMethod.checkbox.auth_app')}
                />
              )}
              {VoterUser.email && (
                <CheckBox
                  checked={activeSelection === 'Email'}
                  onChange={() => onChangeMethod({ method: 'Email' })}
                  label={t('auth.authMethod.checkbox.email')}
                />
              )}
              {VoterUser.phone && (
                <CheckBox
                  checked={activeSelection === 'SMS'}
                  onChange={() => onChangeMethod({ method: 'SMS' })}
                  label={t('auth.authMethod.checkbox.sms')}
                />
              )}
            </div>
          </div>

          <div className={styles['disclaimer']}>
            <SecurityIcon className={styles['disclaimer__icon']} />
            <span className={styles['disclaimer__txt']}>{t('auth.authMethod.banner')}</span>
          </div>

          {serverError && (
            <div className={styles['error']}>
              {nxConfig.supportEmail
                ? t('errors.errorTryAgainContactEmail', { supportEmail: nxConfig.supportEmail })
                : t('errors.errorTryAgainContact')}{' '}
            </div>
          )}
          <div className={styles['action-bar']}>
            <NVButton text={t('buttons.next')} height={50} onClick={onClickNext} disabled={notValid} />
          </div>
        </div>
      </div>
    </div>
  )
}
